// Modules
import React from 'react';

// Components
import TableTabs from '../../components/TableTabs/TableTabs';

// Types
import {
  ICutline,
} from '../../types';

// Config
import {
  AoySections,
  AoySeriesYear,
  DEFAULT_STRING_NO_TABLE_RESULTS,
} from '../../config';

// Content from eat tab.
import AoyFull from './AoyFull';

declare global {
  interface Window { bassConfig: any; }
}

interface IProps {
  // tournament type e.g. 91, 531, 551, etc.
  type: number;
  // Year
  year: number;
  // Cutlines
  aoyCutlines?: ICutline[];
  opensCutlines?: ICutline[];
}
interface IState {
  loading: boolean;
  kayakContent: string;
  type: number;
  year: number;
}

class Aoy extends React.PureComponent<IProps, IState> {
  // Initial state.
  public state: IState = {
    loading: false,
    kayakContent: '',
    type: this.getDefaultTab(),
    year: this.props.year,
  };

  constructor(props) {
    super(props)
    this.updateYear = this.updateYear.bind(this);
    this.getKayakContent = this.getKayakContent.bind(this);
  }

  // Get the index in the series array to get the default tab.
  public getDefaultTab() {
	const series = AoySeriesYear[this.props.year];
    const tab = Object.keys(series).find(key => series[key] === this.props.type);
    return typeof tab !== 'undefined' ? parseInt(tab, 10) : 0;
  }

  // Show cutlines only on AOY and Opens
  public getAoyCutline() {
    const AoyCutlines = {
      91: this.props.aoyCutlines,
      90: this.props.opensCutlines,
    }
    return AoyCutlines[this.props.type];
  }

  public async getKayakContent() {
    this.setState({loading: true});
    try {
      // Grab kayak data page id from global bassConfig (defined in class-bass-blocks.php).
      const { kayakDataId } = window.bassConfig.bass_aoy;
      const res = await fetch(`/wp-json/wp/v2/pages/${kayakDataId}`);
      if (!res.ok) {
        throw new Error(res.statusText);
      }

      // Parse data and assign it to local state if there are results.
      const data = await res.json();
      this.setState({kayakContent: data.content.rendered});
    } catch(e) {
      console.error(e);
      this.setState({kayakContent: `<p style="padding:20px;">${DEFAULT_STRING_NO_TABLE_RESULTS}</p>`})
    } finally {
      this.setState({loading: false});
    }
  }

  // Create a handler to inherit and persist the year change on the children.
  updateYear(year: number, tab?: number) {
    if (year !== 0) {
      this.setState({year});
    }
    if (tab !== undefined) {
      this.setState({type:tab});
    }
  }

  public render() {
    return (
      <>
      {
        this.state.loading ? null : (
          <TableTabs
            defaultTab={this.state.type}
            updateYear={this.updateYear}
          >
            {
              AoySeriesYear[this.state.year].map((element) => {
                return <AoyFull
                  cutlines={this.getAoyCutline()}
                  getKayakContent={this.getKayakContent}
                  kayakContent={this.state.kayakContent}
                  tabLabel={AoySections[element].name}
                  tabClass={`drupal-tab-aoy-${AoySections[element].class}`}
                  type={element}
                  year={this.state.year}
                  updateYear={this.updateYear}
                />
              })
            }
          </TableTabs>
        )
      }
      </>
    );
  };
};

export default Aoy;
